/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1TutoraiDocumentsClassstudentid202,
  PostApiV1TutoraiDocumentsClassstudentid400,
  PostApiV1TutoraiDocumentsClassstudentid401,
  PostApiV1TutoraiDocumentsClassstudentid500,
  PostApiV1TutoraiDocumentsClassstudentidMutationRequest,
  PostApiV1TutoraiDocumentsClassstudentidMutationResponse,
  PostApiV1TutoraiDocumentsClassstudentidPathParams,
} from "../../types/tutorAIDocumentosController/PostApiV1TutoraiDocumentsClassstudentid.ts";
import { tutorAIDocumentSummaryViewModelSchema } from "../tutorAIDocumentSummaryViewModelSchema.ts";

export const postApiV1TutoraiDocumentsClassstudentidPathParamsSchema = z.object(
  {
    classStudentId: z.coerce.number().int(),
  },
) as unknown as ToZod<PostApiV1TutoraiDocumentsClassstudentidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1TutoraiDocumentsClassstudentid202Schema = z.lazy(
  () => tutorAIDocumentSummaryViewModelSchema,
) as unknown as ToZod<PostApiV1TutoraiDocumentsClassstudentid202>;

/**
 * @description Extensão não suportada ou arquivo vazio.
 */
export const postApiV1TutoraiDocumentsClassstudentid400Schema =
  z.any() as unknown as ToZod<PostApiV1TutoraiDocumentsClassstudentid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1TutoraiDocumentsClassstudentid401Schema =
  z.any() as unknown as ToZod<PostApiV1TutoraiDocumentsClassstudentid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1TutoraiDocumentsClassstudentid500Schema =
  z.any() as unknown as ToZod<PostApiV1TutoraiDocumentsClassstudentid500>;

export const postApiV1TutoraiDocumentsClassstudentidMutationRequestSchema =
  z.object({
    file: z.optional(z.instanceof(File)),
  }) as unknown as ToZod<PostApiV1TutoraiDocumentsClassstudentidMutationRequest>;

export const postApiV1TutoraiDocumentsClassstudentidMutationResponseSchema =
  z.lazy(
    () => postApiV1TutoraiDocumentsClassstudentid202Schema,
  ) as unknown as ToZod<PostApiV1TutoraiDocumentsClassstudentidMutationResponse>;
